export default __webpack_public_path__ + "static/media/credscore.2598bf0e.png";